import { useRef, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useTablePagination } from '@gpstrackit/gtc-react-controls';
import { searchAssetProfileEvents } from '../redux/slice';

export const useTableEvents = (selectedProfileId) => {
    const { messages } = useIntl();
    const tableRef = useRef(null);
    const dispatch = useDispatch();
    const { loadingRiskEvents, riskEvents, totalRiskEvents, nextTokenRiskEvents } = useSelector(state => state.driverPerformanceRiskEventsTabRedux || {});

    useEffect(() => {
        if (selectedProfileId) {
            dispatch(searchAssetProfileEvents({ profileId: selectedProfileId, loadMore: false }));
        }
    }, [dispatch, selectedProfileId]);

    const pagination = useTablePagination({
        isLocalData: true,
        infiniteScroll: true,
        tableRef: tableRef,
        searchFields: ['eventName'],
        exportName: 'riskEventsTab',
    });

    const handleChangePage = () => {
        if (selectedProfileId && nextTokenRiskEvents && !loadingRiskEvents) {
            dispatch(searchAssetProfileEvents({ profileId: selectedProfileId, loadMore: true }));
        }
    };

    return {
        tableRef,
        riskEvents,
        totalRiskEvents,
        loadingRiskEvents,
        nextTokenRiskEvents,
        pagination,
        handleChangePage,
        noMoreItemsMessage: messages?.['driver_performance_noMoreItems'] || 'No more items',
        messages,
    };
};
